/*************************************************/
/* COOKIES                                       */
/*************************************************/

export function cookies() {
    const cookiePlaceholderSelector = '.cookie-placeholder';
    const placeholderSelectors = Array.from(document.querySelectorAll(cookiePlaceholderSelector));
    const cookiebotLookupIntervalMs = 100;
    const cookiebotLookupTimeoutMs = 5000;

    //Google Tag Manager injects Cookiebot, so it is not ready when this runs. Its script tag
    //carries id="Cookiebot", which makes window.Cookiebot resolve to that element through
    //named access, so look for the API rather than just the global.
    const GetCookiebot = () => typeof Cookiebot !== 'undefined' && typeof Cookiebot.renew === 'function' ? Cookiebot : null;

    //Keep looking for a while - locally Cookiebot never turns up, and then nothing is gated
    const WhenCookiebotSettled = callback => {
        if (GetCookiebot()) {
            callback();
            return;
        }

        //Against the clock, since a background tab throttles the interval hard
        const deadline = Date.now() + cookiebotLookupTimeoutMs;
        const timer = setInterval(() => {
            if (GetCookiebot() || Date.now() >= deadline) {
                clearInterval(timer);
                callback();
            }
        }, cookiebotLookupIntervalMs);
    }

    //Implement this for the specific cookie solution. Check out one of our other websites for an example
    const RenewConsent = categories => {
        GetCookiebot()?.renew();
    }

    const SetPlaceholderDisplayState = (placeholder,displayState) => {
        placeholder.style.display = displayState;
    }

    //Implement this for the specific cookie solution. Check out one of our other websites for an example. In this case, replace the 'false' with Cookie Consent status
    const SetPlaceholderState = () => {
        const UpdatePlaceholders = function (event) {

            const cookiebot = GetCookiebot();

            const marketingPlaceholders = document.querySelectorAll('[data-categories*="marketing"]');
            if (marketingPlaceholders != null) {
                marketingPlaceholders.forEach(placeholder => {
                    let displayState = !cookiebot || cookiebot.consent.marketing ? 'none' : 'flex';
                    SetPlaceholderDisplayState(placeholder,displayState);
                });
            }
    
            var statisticsPlaceholders = document.querySelectorAll('[data-categories*="statistics"]');
            if (statisticsPlaceholders != null) {
                statisticsPlaceholders.forEach(placeholder => {
                    var displayState = !cookiebot || cookiebot.consent.statistics ? 'none' : 'flex';
                    SetPlaceholderDisplayState(placeholder,displayState);
                });
            }
    
            var preferencesPlaceholders = document.querySelectorAll('[data-categories*="preferences"]');
            if (preferencesPlaceholders != null) {
                preferencesPlaceholders.forEach(placeholder => {
                    var displayState = !cookiebot || cookiebot.consent.preferences ? 'none' : 'flex';
                    SetPlaceholderDisplayState(placeholder,displayState);
                });
            }

        }

        window.addEventListener('CookiebotOnConsentReady', UpdatePlaceholders, false);
        window.addEventListener('CookiebotOnAccept', UpdatePlaceholders, false);
        window.addEventListener('CookiebotOnDecline', UpdatePlaceholders, false);

        //Cookiebot sits in the head and can have answered before this bundle ran, so the
        //event above would never reach us. Nothing to do while its dialog is still open.
        WhenCookiebotSettled(() => {
            const cookiebot = GetCookiebot();
            if (!cookiebot || cookiebot.hasResponse) {
                UpdatePlaceholders();
            }
        });
    }

    const init = () => {

        SetPlaceholderState();

        for(const placeholderSelector of placeholderSelectors) {
            placeholderSelector.addEventListener('click', event => {
                let placeholder = event.target;
                if(!placeholder.classList.contains(cookiePlaceholderSelector)) {
                    placeholder = event.target.closest(cookiePlaceholderSelector);
                }
                event.stopPropagation()
                var categories = placeholder.dataset.categories.split(',');
                RenewConsent(categories);
            });
        }
    };

    init();
}